<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/simpeg-pegawai-list">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Tambah Pegawai
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Tambah Pegawai</h5>
    </div>
    <div class="content-block">
      <DxPopup
        v-model:visible="popupPasanganVisible"
        :drag-enabled="false"
        :hide-on-outside-click="true"
        :show-close-button="false"
        :show-title="true"
        :height="inherit"
        container=".dx-viewport"
        title="Cari NIK Pegawai"
        :width="450"
      >
        <DxToolbarItem
          widget="dxButton"
          toolbar="top"
          locate-in-menu="always"
          :options="moreInfoButtonOptions"
        />
        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          :options="closeButtonOptionsPasangan"
        />

        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="before"
          :options="deleteButtonOptionsPasangan"
        />

        <!-- <div style="padding-bottom: 30px"> -->
        <div>
          <DxDataGrid
            class="dx-card"
            :data-source="pegawaiListDataSource"
            :focused-row-index="0"
            :show-borders="true"
            :show-column-lines="false"
            :focused-row-enabled="true"
            :column-auto-width="true"
            :column-hiding-enabled="false"
            :allow-column-reordering="true"
          >
            <dx-paging :page-size="5" />
            <dx-pager :show-page-size-selector="true" :show-info="true" />
            <dx-filter-row :visible="true" />

            <dx-column data-field="nik" caption="NIK" :allow-sorting="true" />
            <dx-column
              data-field="nama"
              caption="Nama Pegawai"
              :allow-sorting="true"
            />
            <DxColumn
              data-field="id"
              caption="Pilih"
              cell-template="pilih-template"
            >
            </DxColumn>
            <!-- <DxColumn type="buttons">
                <DxButton hint="Pilih" icon="copy" @click="cloneIconClick" />
              </DxColumn> -->

            <template #pilih-template="{ data }">
              <div class="small-button-container">
                <!-- {{ "rowIndex " + data.rowIndex }}
                    {{ showPopUpPasangan(data) }} -->

                <DxButton
                  @click="handleClickPilihPasangan(data)"
                  icon="check"
                  hint="pilih"
                  type="default"
                />
              </div>
            </template>
          </DxDataGrid>
        </div>
      </DxPopup>

      <div class="dx-card responsive-paddings">
        <DxTabPanel
          id="tabPanel"
          ref="myTabPanel"
          v-model:selected-index="tabPanelIndex"
          :data-source="tabData"
          :animation-enabled="true"
          item-title-template="title"
          item-template="currentTemplate"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #t2>
            <DxDataGrid
              id="dataGridKeluarga2"
              :data-source="keluargaSource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
              key-expr="id"
            >
              <dx-paging :page-size="10" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />
              <DxToolbar>
                <DxItem name="groupPanel" />
                <DxItem location="after" template="button-template" />
                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>
              <template #button-template>
                <DxButton
                  text="Import data"
                  :width="136"
                  @click="importClick"
                />
              </template>
              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                mode="row"
                :new-row-position="bottom"
              />
              <DxSorting mode="multiple" />
              <dx-column
                data-field="keluarga_hub_id"
                caption="Hubungan Keluarga"
                sort-order="asc"
              >
                <DxLookup
                  :data-source="keluargaHubSource"
                  value-expr="id"
                  display-expr="nama"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column data-field="nama" caption="Nama">
                <DxRequiredRuleDataGrid
              /></dx-column>

              <dx-column data-field="nik" caption="NIK" data-type="number">
              </dx-column>

              <DxColumn data-field="tempat_lahir" caption="Tempat Lahir">
              </DxColumn>
              <dx-column
                data-field="tgl_lahir"
                caption="Tgl lahir"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
              >
              </dx-column>

              <dx-column
                data-field="perkawinan_status_id"
                caption="Status Pernikahan"
              >
                <DxLookup
                  :data-source="perkawinanStatusSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </dx-column>

              <dx-column data-field="jenis_kelamin" caption="Jenis kelamin">
                <DxLookup :data-source="jenisKelaminSource" />
              </dx-column>
              <DxColumn data-field="" caption="Pekerjaan"></DxColumn>
              <dx-column data-field="agama_id" caption="Agama">
                <DxLookup
                  :data-source="agamaSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </dx-column>
            </DxDataGrid>

            <DxButton
              @click="validateClick('t2', $event)"
              text="Next"
              type="default"
              class="validate"
            />
          </template>

          <template #t3>
            <DxDataGrid
              ref="dataGridRefKey"
              id="dataGridEdFormal"
              :data-source="pendidikanSource"
              :show-borders="true"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
            >
              <dx-paging :page-size="10" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />
              <DxToolbar>
                <DxItem name="groupPanel" />
                <DxItem location="after" template="button-template" />
                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>
              <template #button-template>
                <DxButton
                  text="Import data"
                  :width="136"
                  @click="importClick"
                />
              </template>
              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                mode="row"
                :new-row-position="bottom"
              />
              <DxSorting mode="multiple" />

              <dx-column
                data-field="pendidikan_jenjang_id"
                caption="Jenjang"
                sort-order="asc"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="pendidikanJenjangSource"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column data-field="institusi" caption="Nama institusi">
                <DxRequiredRuleDataGrid
              /></dx-column>
              <dx-column data-field="fakultas" caption="Fakultas"> </dx-column>
              <dx-column data-field="jurusan" caption="Jurusan"> </dx-column>
              <dx-column data-field="ipk" caption="IPK" data-type="number">
                <DxPatternRule
                  :pattern="patternNumeric"
                  message="IPK adalah angka!"
                />
              </dx-column>
              <dx-column data-field="tahun_mulai" caption="Tahun Mulai">
                <DxPatternRule :pattern="patternTahun" message="Tahun salah" />
              </dx-column>
              <dx-column data-field="tahun_lulus" caption="Tahun Lulus">
                <DxPatternRule :pattern="patternTahun" message="Tahun salah" />
              </dx-column>
              <dx-column data-field="ijazah_no" caption="Nomor Ijazah">
              </dx-column>

              <dx-column
                data-field="ijazah_tgl"
                caption="Tgl Ijazah"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
              >
                <!-- <DxPatternRule
                  :pattern="patternDMY"
                  message="Format tgl dd-mm-yyyy!"
                /> -->

                <!-- <DxPatternRule
                  :pattern="pattern"
                  message='Your phone must have "(555) 555-5555" format!'
                /> -->
              </dx-column>

              <!-- <dx-column
                data-field="ijazah_tgl"
                caption="Tgl Ijazah"
                data-type="date"
                :format="'dd-MM-yyyy'"
                :validationRules="[
                  {
                    type: 'pattern',
                    pattern:
                      /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-[0-9]{4}$/,
                    message: 'Tanggal must be in the format dd-mm-yyyy',
                  },
                ]"
              >
              </dx-column> -->

              <!-- <dx-column
                data-field="ijazah_tgl"
                caption="Tgl Ijazah"
                data-type="date"
                :format="'dd-MM-yyyy'"
                :editor-options="editorOptions"
              >
              </dx-column> -->
            </DxDataGrid>
            <DxButton
              @click="validateClick('t3', $event)"
              text="Submit"
              type="default"
              class="validate"
            />
          </template>

          <template #t1>
            <div class="editors" style="padding-top: 25px">
              <div class="row row-cols-1 row-cols-md-3">
                <div class="col">
                  <div class="editors-container">
                    <div class="left">
                      <DxTextBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        label="NIK"
                        placeholder="NIK"
                        v-model="pegawaiSource.nik"
                      >
                        <DxValidator>
                          <DxRequiredRule />
                          <DxNumericRule message="NIK adalah angka" />
                        </DxValidator>
                      </DxTextBox>
                      <DxTextBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        label="Nama"
                        placeholder="Nama"
                        v-model="pegawaiSource.nama"
                      >
                        <DxValidator>
                          <DxRequiredRule />
                        </DxValidator>
                      </DxTextBox>
                      <DxTextBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        label="Tempat lahir"
                        placeholder="Tempat lahir"
                        v-model="pegawaiSource.tempat_lahir"
                      >
                      </DxTextBox>

                      <DxTextBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        label="Telp"
                        placeholder="Telp"
                        v-model="pegawaiSource.telp"
                      >
                      </DxTextBox>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="editors-container">
                    <div class="left">
                      <DxDateBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        :display-format="'dd/MM/yyyy'"
                        width="100%"
                        placeholder="Tgl mulai bekerja"
                        label="Tgl mulai bekerja"
                        v-model="pegawaiSource.tgl_mulai_bekerja"
                      >
                        <DxValidator>
                          <DxRequiredRule />
                        </DxValidator>
                      </DxDateBox>

                      <DxTextBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        label="Alamat"
                        placeholder="Alamat"
                        v-model="pegawaiSource.alamat"
                      >
                      </DxTextBox>
                      <DxDateBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        :display-format="'dd/MM/yyyy'"
                        width="100%"
                        placeholder="Tgl lahir"
                        label="Tgl lahir"
                        v-model="pegawaiSource.tgl_lahir"
                      >
                      </DxDateBox>
                      <DxSelectBox
                        :dataSource="agamaSource"
                        valueExpr="id"
                        displayExpr="nama"
                        :searchEnabled="true"
                        searchExpr="nama"
                        search-mode="startswith"
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        placeholder="Agama"
                        label="Agama"
                        v-model="pegawaiSource.agama_id"
                      >
                        <DxValidator>
                          <DxRequiredRule />
                        </DxValidator>
                      </DxSelectBox>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="editors-container">
                    <div class="left">
                      <DxSelectBox
                        :dataSource="statusSource"
                        valueExpr="val"
                        displayExpr="nama"
                        :searchEnabled="true"
                        searchExpr="nama"
                        search-mode="startswith"
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        placeholder="Status pensiun jiwasraya"
                        label="Status pensiun jiwasraya"
                        v-model="pegawaiSource.pensiun_jiwasraya"
                      >
                      </DxSelectBox>
                      <DxSelectBox
                        :dataSource="statusSource"
                        valueExpr="val"
                        displayExpr="nama"
                        :searchEnabled="true"
                        searchExpr="nama"
                        search-mode="startswith"
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        placeholder="Status PPH"
                        label="Status PPH"
                        v-model="pegawaiSource.pph"
                      >
                      </DxSelectBox>
                      <DxTextBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        label="Status PTKP"
                        placeholder="Status PTKP"
                        v-model="pegawaiSource.status_ptkp"
                      >
                      </DxTextBox>
                      <DxSelectBox
                        :dataSource="statusSource"
                        valueExpr="val"
                        displayExpr="nama"
                        :searchEnabled="true"
                        searchExpr="nama"
                        search-mode="startswith"
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        placeholder="Status tanggungan keluarga"
                        label="Status tanggungan keluarga"
                        v-model="pegawaiSource.status_tanggungan_keluarga"
                      >
                      </DxSelectBox>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="center">
                <DxTagBox
                  :items="positions"
                  :value="['Support Manager']"
                  :multiline="false"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  placeholder="Select..."
                  label="Position"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxTagBox>
              </div> -->
              <div class="center">
                <label for="fileUploader">Foto profil pegawai:</label>
                <DxFileUploader
                  ref="fileUploader"
                  accept="image/*"
                  upload-mode="useForm"
                  name="files"
                  multiple="false"
                  @value-changed="handleFileUploader($event, 'pegawai_foto')"
                >
                </DxFileUploader>
              </div>
              <div class="center">
                <DxButton
                  @click="validateClick('t1', $event)"
                  text="Next"
                  type="default"
                  class="validate"
                />
              </div>
            </div>
          </template>
        </DxTabPanel>

        <!-- <div class="options">
          <div class="caption">Options</div>
          <div class="option">
            <label>Styling Mode</label>
            <DxSelectBox
              :items="['outlined', 'filled', 'underlined']"
              v-model:value="stylingMode"
            />
          </div>
          <div class="option">
            <label>Label Mode</label>
            <DxSelectBox
              :items="['static', 'floating', 'hidden']"
              v-model:value="labelMode"
            />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { DateTime } from "luxon";
import DxTabPanel from "devextreme-vue/tab-panel";
import DxSelectBox from "devextreme-vue/select-box";
import DxTextBox from "devextreme-vue/text-box";
import axios from "axios";
// import DxTextArea from "devextreme-vue/text-area";
// import DxTagBox from "devextreme-vue/tag-box";
import DxDateBox from "devextreme-vue/date-box";
import DxButton from "devextreme-vue/button";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import {
  DxValidator,
  DxRequiredRule,
  DxNumericRule,
} from "devextreme-vue/validator";
import notify from "devextreme/ui/notify";
import ODataStore from "devextreme/data/odata/store";
import service from "./pegawai-add-data.js";
import _ from "lodash";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxEditing,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxToolbar,
  DxLookup,
  DxItem,
  DxPatternRule,
  DxSorting,
  DxRequiredRule as DxRequiredRuleDataGrid,
} from "devextreme-vue/data-grid";
import { DxFileUploader } from "devextreme-vue/file-uploader";
import DataSource from "devextreme/data/data_source";

function formatDateISO(dateOri) {
  const date = DateTime.fromJSDate(new Date(dateOri));
  return date.toFormat("yyyy-MM-dd");
}
// const dataGridRefKey = "myDataGrid";
export default {
  components: {
    DxSelectBox,
    DxTextBox,
    // DxTextArea,
    // DxTagBox,
    DxDateBox,
    DxButton,
    DxValidator,
    DxTabPanel,
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxPager,
    DxPaging,
    DxEditing,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxToolbar,
    DxLookup,
    DxItem,
    DxRequiredRule,
    DxNumericRule,
    DxRequiredRuleDataGrid,
    DxPatternRule,
    DxSorting,
    DxFileUploader,
    DxPopup,
    DxToolbarItem,
  },
  data() {
    return {
      // dataGridRefKey,
      // pendidikanHistorySource: [
      //   {
      //     id: "",
      //     pendidikan_jenjang_id: "",
      //     institusi: "",
      //     fakultas: "",
      //     jurusan: "",
      //     ipk: "",
      //     tahun_mulai: "",
      //     tahun_lulus: "",
      //     ijazah_no: "",
      //     ijazah_tanggal: "",
      //     ijazah_file: "",
      //   },
      // ],
      // patternTglYMD: /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/,
      // patternTglYMD: /^\d{4}-\d{2}-\d{2}$/,
      // patternTglYMD: /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/, //INI YANG BENER YMD
      // patternTglYMD: /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-[0-9]{4}$/, //INI YANG BENER DMY

      // patternTglYMD: /^\d{3}-\d{2}-\d{4}$/,
      patternDMY: /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-[0-9]{4}$/,
      editorOptions: { mask: "99-99-9999", useMaskBehavior: true },
      pattern: /^\(\d{3}\) \d{3}-\d{4}$/i,
      patternTahun: /^\d{4}$/i,
      patternNumeric: /^\d+(?:[.,]\d+)?$/,

      pendidikanSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      keluargaSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      tabPanelIndex: 0,
      agamaSource: new ODataStore({
        url: "http://127.0.0.1/odata/Agamas",
        key: "id",
      }),
      jabatanSource: new ODataStore({
        url: "http://127.0.0.1/odata/Jabatans",
        key: "id",
      }),
      golonganSource: new ODataStore({
        url: "http://127.0.0.1/odata/Golongans",
        key: "id",
      }),
      bagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/Bagians",
        key: "id",
      }),
      subBagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/SubBagians",
        key: "id",
      }),
      cabangSource: new ODataStore({
        url: "http://127.0.0.1/odata/Cabangs",
        key: "id",
      }),
      pendidikanJenjangSource: new ODataStore({
        url: "http://127.0.0.1/odata/PendidikanJenjangs",
        key: "id",
      }),
      jenisKelaminSource: ["L", "P"],
      perkawinanStatusSource: new ODataStore({
        url: "http://127.0.0.1/odata/PerkawinanStatuses",
        key: "id",
      }),
      keluargaHubSource: new ODataStore({
        url: "http://127.0.0.1/odata/KeluargaHubs",
        key: "id",
      }),

      tabData: [
        {
          text: "Data Pegawai",
          template: "t1",
          disabled: false,
        },
        {
          text: "Data Keluarga",
          template: "t2",
          disabled: true,
        },
        {
          text: "Data Riwayat Pendidikan",
          template: "t3",
          disabled: true,
        },
      ],
      birthDate: new Date(1981, 5, 3),
      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",
      text: "Olivia loves to sell. She has been selling DevAV products since 2012.",
      positions: service.getPositions(),
      states: service.getStates(),
      phoneRules: {
        X: /[02-9]/,
      },
      pegawaiSource: {
        nik: "",
        nama: "",
        tempat_lahir: "",
        tgl_lahir: "",
        telp: "",
        tgl_mulai_bekerja: "",
        alamat: "",
        agama_id: 1,
        pensiun_jiwasraya: "",
        pph: "",
        status_ptkp: "",
        status_tanggungan_keluarga: "",
      },

      pegawai_foto: null,
      pegawa_foto_non_binary: null,
      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Non Aktif" },
      ],
    };
  },

  methods: {
    handleClickDeletePasangan() {
      this.popupPasanganVisible = false;
      const dataGridInstance = this.$refs.dataGridrKeluargaRef.instance;
      dataGridInstance.cellValue(this.rKeluargaRowIndex, "pasangan.nik", "");

      dataGridInstance.cellValue(this.rKeluargaRowIndex, "pasangan_id", "");
      dataGridInstance.saveEditData();
    },
    handleClickPilihPasangan(data) {
      this.popupPasanganVisible = false;

      const dataGridInstance = this.$refs.dataGridrKeluargaRef.instance;
      // console.log(this.$refs.dataGridrKeluargaRef);

      dataGridInstance.cellValue(
        this.rKeluargaRowIndex,
        "pasangan.nik",
        data.data.nik
      );
      dataGridInstance.cellValue(
        this.rKeluargaRowIndex,
        "nama",
        data.data.nama
      );

      dataGridInstance.cellValue(
        this.rKeluargaRowIndex,
        "pasangan_id",
        data.data.id
      );
      dataGridInstance.saveEditData();
    },

    handleFileUploader(e, column) {
      console.log("================================");
      console.log(e);
      console.log(column);
      this.pegawai_foto = e.value[0];
      this.pegawa_foto_non_binary = e.value[0];
      let reader = new FileReader();
      reader.onloadend = () => {
        this.imagePreviewUrl = reader.result;
      };
      reader.readAsDataURL(this.pegawai_foto);
    },

    validateClick(tabSelected, e) {
      console.log("VALIDATECLICK");
      console.log("pegawaiSource", this.pegawaiSource);
      console.log("pendidikanSource", this.pendidikanSource);

      const result = e.validationGroup.validate();
      if (result.isValid) {
        console.log("VALIDATECLICK 2");
        // notify("The task was saved successfully.", "success");
        //enable next step
        const nextTab = _.parseInt(_.nth(tabSelected, 1));
        this.tabPanelIndex = nextTab;
        // this.pegawais.tgl_lahir = formatDateISO(this.pegawais.tgl_lahir);
        if (nextTab < _.size(this.tabData)) {
          this.tabData[nextTab]["disabled"] = false;
          console.log("MASIH ADA NEXT TAB");
        }

        if (nextTab >= _.size(this.tabData)) {
          console.log("VALIDATECLICK 3");
          //ini tab terakhir
          postDatabase(
            this.pegawaiSource,
            this.pendidikanSource,
            this.keluargaSource,
            this.pegawai_foto,
            this.pegawa_foto_non_binary
          );
        }
        // this.$refs.myTabPanel.selectedIndex = nextTab;
      } else {
        console.log("VALIDATECLICK 4");
        console.log(this.pendidikanSource);
        notify(
          "The task was not saved. Please check if all fields are valid.",
          "error"
        );
      }
    },
  },
};

function postDatabase(
  pegawais,
  pendidikan_histories,
  keluargas,
  pegawai_foto,
  pegawai_foto_non_binary
) {
  console.log("POSTDATABASE ");
  console.log("pegawais", pegawais);
  console.log("keluargas", keluargas.items());
  console.log("pendidikan_histories", pendidikan_histories);
  console.log("pendidikan_histories.items", pendidikan_histories.items());

  pegawais.tgl_lahir = formatDateISO(pegawais.tgl_lahir);
  pegawais.tgl_mulai_bekerja = formatDateISO(pegawais.tgl_mulai_bekerja);
  if (pegawais.tgl_lahir == "Invalid DateTime") pegawais.tgl_lahir = "";
  if (isDateInvalid(pegawais.tgl_lahir)) pegawais.tgl_lahir = "";
  // _.assign(
  //   pendidikan_histories,
  //   _.map(pendidikan_histories, (row) => {
  //     row.ijazah_tgl = formatDateISO(row.ijazah_tgl);
  //     console.log(row.ijazah_tgl);
  //     return row;
  //   })
  // );

  // const modified = formatDataISOFromArray(pendidikan_histories, "ijazah_tgl");

  // _.forEach(pendidikan_histories, (item) => {
  //   if (isDateInvalid(item.ijazah_tgl)) item.ijazah_tgl = "";
  //   else item.ijazah_tgl = formatDateISO(item.ijazah_tgl);
  // });

  // _.forEach(keluargas, (item) => {
  //   if (isDateInvalid(item.tgl_lahir)) item.tgl_lahir = "";
  //   else item.tgl_lahir = formatDateISO(item.tgl_lahir);
  // });

  const config = {
    headers: {
      // "content-type": "application/json",
      "content-type": "multipart/form-data",
    },
  };
  axios
    .post(
      "http://127.0.0.1/api/simpeg_pegawai",
      {
        pegawais: pegawais,
        pendidikan_histories: pendidikan_histories.items(),
        keluargas: keluargas.items(),
        pegawai_foto: pegawai_foto_non_binary,
      },
      config
    )
    .then(function (res) {
      console.log(res);
      notify("Data Pegawai berhasil ditambahkan.", "success");
      router.push({
        name: "simpeg-pegawai-detail",
        query: { id: res.data.id },
      });
    })
    .catch(function (err) {
      console.log(err);
      notify("data Pegawai gagal ditambahkan.", "error");
    });
}

function isDateInvalid(dateString) {
  const date = new Date(dateString);
  return isNaN(date);
}
</script>
<style>
.title {
  padding: 20px 0 20px 0;
  font-size: 18px;
  font-weight: 500;
}

.editors {
  /* margin-right: 320px; */
  height: 570px;
  width: 100%;
}

.editors .left {
  padding: 0 10px 0 0;
}

.editors .right {
  padding: 0 0 0 10px;
}

.editors .left,
.editors .right {
  flex-grow: 1;
}

.editors .left > *,
.editors .right > *,
.editors .center > * {
  margin-bottom: 20px;
}

.editors .center {
  padding: 0 27px 0 0;
}

.validate {
  float: right;
}

.options {
  padding: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 260px;
  top: 0;
  background-color: rgba(191, 191, 191, 0.15);
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 20px;
}

.editors-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 27px;
}
</style>
